import { useEffect } from "react";
import { useFileStore } from "../../../../store/useFileStore";

const DocComponentsCategoryJson = () => {
    // eslint-disable-next-line no-unused-vars
    const [_, setStore] = useFileStore((store) => store);

    useEffect(() => {
        let value = `{
    "label": "Components",
    "position": 4,
    "collapsible": false,
    "collapsed": false
}`;

        setStore({ docComponentsCategoryJson: value });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return null;
};

export default DocComponentsCategoryJson;
